import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { InputLabelReact } from 'common/components/input/label';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { TagInputReact } from 'common/components/tag-input';
import { TagInputSearchMode } from 'common/components/tag-input/types';
import { useDraftExperiment } from 'iron/apps/experiments/src/components/hooks/draft-experiment';
import { useExperimentOptions } from 'iron/apps/experiments/src/components/hooks/experiment-options';
import styles from '../index.module.styl';
export function CollectionMethodExposureEvents() {
  var _draftExperiment$sett2, _draftExperiment$sett3, _draftExperiment$sett4, _draftExperiment$sett5, _draftExperiment$sett6;
  const i18n = useTranslation();
  const draftExperiment = useExperimentsStore(state => state.draftExperiment);
  const {
    updateDraft
  } = useDraftExperiment();
  const {
    experimentNames,
    variantNames
  } = useExperimentOptions();
  React.useEffect(() => {
    var _draftExperiment$sett;
    if (!(draftExperiment !== null && draftExperiment !== void 0 && (_draftExperiment$sett = draftExperiment.settings) !== null && _draftExperiment$sett !== void 0 && _draftExperiment$sett.controlKey) && variantNames.length > 0) {
      updateDraft({
        settings: {
          controlKey: variantNames[0]
        }
      });
    }
  }, [variantNames, draftExperiment === null || draftExperiment === void 0 || (_draftExperiment$sett2 = draftExperiment.settings) === null || _draftExperiment$sett2 === void 0 ? void 0 : _draftExperiment$sett2.controlKey]);
  const handleEditExperimentName = (value: string) => {
    setTimeout(() => {
      updateDraft({
        settings: {
          exposureEventSettings: {
            experimentName: value
          },
          controlKey: ""
        }
      });
    });
  };
  const handleEditControlKey = (value: string) => {
    setTimeout(() => {
      updateDraft({
        settings: {
          controlKey: value
        }
      });
    });
  };
  if (!draftExperiment) {
    return null;
  }
  return <>
      <div>
        <InputLabelReact fieldId='experiment-exposure-event' label={i18n.t("experiments.setup.form.exposure-events.experiment-name")} helpText={i18n.t("experiments.setup.form.exposure-events.experiment-name-info")} necessary='required' data-sentry-element="InputLabelReact" data-sentry-source-file="exposure-events.tsx" />
        <TagInputReact className={styles.fullWidth} menuSections={[{
        items: experimentNames.map(name => {
          return {
            label: name,
            value: name
          };
        })
      }]} controlledMode searchMode={TagInputSearchMode.Combobox} mpItemsMenuAttrs={{
        'empty-message': i18n.t("experiments.setup.form.no-experiment-results"),
        'empty-search-results-message': i18n.t("experiments.setup.form.no-experiment-results")
      }} value={(_draftExperiment$sett3 = draftExperiment === null || draftExperiment === void 0 || (_draftExperiment$sett4 = draftExperiment.settings) === null || _draftExperiment$sett4 === void 0 || (_draftExperiment$sett4 = _draftExperiment$sett4.exposureEventSettings) === null || _draftExperiment$sett4 === void 0 ? void 0 : _draftExperiment$sett4.experimentName) !== null && _draftExperiment$sett3 !== void 0 ? _draftExperiment$sett3 : ""} onChange={(ev: TODO) => {
        var _ev$detail$value;
        handleEditExperimentName(((_ev$detail$value = ev.detail.value) !== null && _ev$detail$value !== void 0 ? _ev$detail$value : "").trim());
      }} onClickMenuItem={(ev: TODO) => {
        handleEditExperimentName(ev.detail.value);
      }} data-sentry-element="TagInputReact" data-sentry-source-file="exposure-events.tsx" />
      </div>
      <div>
        <InputLabelReact fieldId='experiment-control-key' label={i18n.t("experiments.setup.form.control-key")} helpText={i18n.t("experiments.setup.form.control-key-info")} necessary='required' data-sentry-element="InputLabelReact" data-sentry-source-file="exposure-events.tsx" />
        <TagInputReact className={styles.fullWidth} menuSections={[{
        items: variantNames.map(name => {
          return {
            label: name,
            value: name
          };
        })
      }]} controlledMode searchMode={TagInputSearchMode.Combobox} mpItemsMenuAttrs={{
        'empty-message': i18n.t("experiments.setup.form.no-variant-results"),
        'empty-search-results-message': i18n.t("experiments.setup.form.no-variant-results")
      }} value={(_draftExperiment$sett5 = draftExperiment === null || draftExperiment === void 0 || (_draftExperiment$sett6 = draftExperiment.settings) === null || _draftExperiment$sett6 === void 0 ? void 0 : _draftExperiment$sett6.controlKey) !== null && _draftExperiment$sett5 !== void 0 ? _draftExperiment$sett5 : ""} onChange={(ev: TODO) => {
        var _ev$detail$value2;
        handleEditControlKey(((_ev$detail$value2 = ev.detail.value) !== null && _ev$detail$value2 !== void 0 ? _ev$detail$value2 : "").trim());
      }} onClickMenuItem={(ev: TODO) => {
        handleEditControlKey(ev.detail.value);
      }} data-sentry-element="TagInputReact" data-sentry-source-file="exposure-events.tsx" />
      </div>
    </>;
}